module.exports = __webpack_public_path__ + "static/media/img3-1.3a7310ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/cana/nutricheck_foliar/FE/img3-1.png
// module id = 1286
// module chunks = 3